import { useMonarchRule } from "../MonarchRulesProvider";
import { DynamicExperienceFlowData, UseDynamicExperienceFlow } from "./types";

const RULE_ID = "dynamicExperienceFlow";

const useDynamicExperienceFlow: UseDynamicExperienceFlow = (payload) => {
  const { isLoading, value } = useMonarchRule<DynamicExperienceFlowData>(
    RULE_ID,
    payload as Record<string, unknown> | undefined,
  );

  // If loading or no value, return control
  if (isLoading) {
    return {
      isLoading,
      variant: "control",
    };
  }

  // Determine variant based on flowId presence
  // If we have a flowId, we are in the "test" variant (active flow)
  // Otherwise "control"
  const variant = value?.flowId ? "test" : "control";

  return {
    isLoading,
    variant,
    data: value || {},
  };
};

export default useDynamicExperienceFlow;
